import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/premik";

export const createRelocation = createAsyncThunk(
  "relocation/create",
  async (relocation, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(baseUrl, relocation);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchRelocationPage = createAsyncThunk(
  "relocation/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const relocationSlice = createSlice({
  name: "relocation",
  initialState: {
    error: null,
    isLoading: false,
    page: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createRelocation.fulfilled, (state, _) => {
        state.isLoading = false;
      })
      .addCase(createRelocation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createRelocation.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRelocationPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchRelocationPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchRelocationPage.pending, (state, _action) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export default relocationSlice.reducer;
